// eslint-disable-next-line max-classes-per-file
const queryString = require('query-string');
const ext = require('deep-extend');
const q = require('queried');
const delegate = require('emmy/delegate');
const {
  Filter,
} = require('./filter');
const {
  Controller,
} = require('./core');

/**
 * Get search initial state from URL.
 *
 * @param element
 * @returns {{search: *, searchLocationLabel: (*|string)}}
 */
function getInitialState(element) {
  const fields = [
    'ctype',
    'include_inactual',
    'q',
    'location',
  ];

  const query = queryString.parse(window.location.search);

  const search = fields.reduce((result, field) => {
    if (query[field]) {
      return ext(result, {
        [field]: [query[field]],
      });
    }

    return result;
  }, {});

  const locationSwitcherLabel = q('.location-switcher span', element);

  return {
    search,
    searchLocationLabel: locationSwitcherLabel.innerText,
  };
}

class SearchController extends Controller {
  constructor(...args) {
    super(...args);

    const initialState = getInitialState(this.view.element);

    this.model.update((state) => ext(state, initialState));
  }

  /**
   * Perform search on typing after delay.
   *
   * @param str
   * @param delay
   */
  query(str, delay = 500) {
    const setTimer = () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.model.updateWithSync((state) => ext(state, {
          search: {
            q: str,
          },
        }));
      }, delay);
    };

    setTimer();
  }

  reset(key) {
    this.model.updateWithSync((state) => {
      if (state.search) {
        delete state.search[key];
      }

      return state;
    });
  }

  enable(key, value) {
    if (value) {
      this.model.updateWithSync((state) => ext(state, {
        search: {
          [key]: [value],
        },
      }));
    } else {
      this.reset(key);
    }
  }

  toggle(key, value) {
    this.model.updateWithSync((state) => {
      const values = (state.search && state.search[key]) || [];

      if (values.indexOf(value) == -1) {
        values.push(value);
      } else {
        values.splice(values.indexOf(value), 1);
      }

      return ext(state, {
        search: {
          [key]: values.filter((x) => x.length),
        },
      });
    });
  }

  switchLocation(locationValue, locationLabelText) {
    this.model.updateWithSync((state) => ext(state, {
      search: {
        location: locationValue,
      },
      searchLocationLabel: locationLabelText,
    }));
  }

  sync(data, state) {
    if (data.type_count) {
      state.searchCounters = data.type_count;
    }

    return state;
  }
}

class Search extends Filter {
  constructor(...args) {
    super(...args);

    this.events.bind('input #search-input', (e) => this.emit('query', e.delegateTarget.value));

    this.events.bind('keypress #search-input', (e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    });

    const cityItemSelector = '.cities-menu-search-dropdown .cities-menu-item-link';
    delegate(document.body, 'click', cityItemSelector, (e) => this.switchLocation(e));
  }

  render(state) {
    const data = state.search;
    if (data) {
      this.renderTabs(data);
      this.renderCheckboxes(data);
    }

    if (state.searchCounters) {
      this.renderCounters(state.searchCounters);
    }

    if (state.searchLocationLabel) {
      const locationSwitcherText = q('.location-switcher span', this.element);
      locationSwitcherText.innerHTML = state.searchLocationLabel;
    }
  }

  renderTabs(data) {
    const tabs = q.all('.tab', this.element);
    tabs.forEach((tab) => tab.classList.remove('active'));

    const ctype = data.ctype && data.ctype[0] || 'all';
    const activeTabSelector = `#tab-${ctype}`;
    const activeTab = q(activeTabSelector, this.element);
    activeTab.classList.add('active');
  }

  renderCheckboxes(data) {
    const elements = q.all('[data-key] .checkbox', this.element);
    elements.forEach((elem) => {
      const container = elem.closest('[data-key]');
      if (container) {
        const key = container.getAttribute('data-key');
        const checked = data[key] && data[key].length;
        if (checked) {
          elem.classList.add('checked');
        } else {
          elem.classList.remove('checked');
        }
      }
    });
  }

  renderCounters(counters) {
    const counterKeys = Object.keys(counters);
    q.all('.tab[data-key="ctype"] .count', this.element).forEach((elem) => {
      elem.innerHTML = '0';
    });
    counterKeys.forEach((key) => {
      const counter = key != 'null'
        ? q(`.tab[data-key="ctype"][data-value="${key}"] .count`, this.element)
        : q('.tab[data-key="ctype"][data-mode="reset"] .count', this.element);

      counter.innerHTML = counters[key];
    });
  }

  switchLocation(e) {
    const target = e.delegateTarget;
    const value = target.getAttribute('data-value');
    const locationText = q('span', target).textContent;

    this.emit('switchLocation', value, locationText);

    e.preventDefault();
  }
}

module.exports = {
  SearchController,
  Search,
};
